module.exports = __webpack_public_path__ + "static/text-bbbe6992f4efb87878a83b9ba8af8b0a.png";